module.exports = __webpack_public_path__ + "media/flags/uz-93b0b48f.svg";